import request from '@/utils/request'

//获取个人信息
export function wxgetinfo(data) {
  return request({
    url: 'wxgetinfo',
    method: 'post',
    data
  })
}

//微信扫码登录接口
export function wxlogin(data) {
  return request({
    url: 'wxlogin',
    method: 'post',
    data
  })
}

//微信用户退出登录
export function wxlogout(data) {
  return request({
    url: 'wxlogout',
    method: 'post',
    data
  })
}

//获取推荐会员列表
export function tuijian_user_list(data) {
  return request({
    url: 'tuijian_user_list',
    method: 'post',
    data
  })
}

//获取临时登录二维码
export function lunxun(data) {
  return request({
    url: 'lunxun',
    method: 'post',
    data
  })
}

//环境统一下单接口
export function pc_pay(data) {
  return request({
    url: 'pc_pay',
    method: 'post',
    data
  })
}

//用户修改个人信息
export function user_save_info(data) {
  return request({
    url: 'user_save_info',
    method: 'post',
    data
  })
}

//用户查看自己的开博信息
export function user_look_kaibo(data) {
  return request({
    url: 'user_look_kaibo',
    method: 'post',
    data
  })
}

//用户提交开博申请
export function user_kaobo_save(data) {
  return request({
    url: 'user_kaobo_save',
    method: 'post',
    data
  })
}

//关注或者取消关注用户
export function user_guanzhu(data) {
  return request({
    url: 'user_guanzhu',
    method: 'post',
    data
  })
}

//获取我关注的用户列表
export function user_guanzhu_list(data) {
  return request({
    url: 'user_guanzhu_list',
    method: 'post',
    data
  })
}

//关注我的用户列表
export function user_woguanzhu_list(data) {
  return request({
    url: 'user_woguanzhu_list',
    method: 'post',
    data
  })
}

//获取消息未读
export function user_xiaoxi_num(data) {
  return request({
    url: 'user_xiaoxi_num',
    method: 'post',
    data
  })
}

//获取消息列表
export function user_xiaoxi_list(data) {
  return request({
    url: 'user_xiaoxi_list',
    method: 'post',
    data
  })
}

//删除消息
export function user_xiaoxi_delete(data) {
  return request({
    url: 'user_xiaoxi_delete',
    method: 'post',
    data
  })
}

//清空消息
export function user_xiaoxi_deleall(data) {
  return request({
    url: 'user_xiaoxi_deleall',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/user.js